var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminPage',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$t('content.nodes.title')))]),_c('template',{slot:"navigation"},[_c('NodeNavigation')],1),_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }